import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    sitio_peritaje: '',
    encargado: '',
    fecha: '',
    hora: ''
};
const mutations = {
    updateField,
    updateInspeccion: (state, payload) => {
        var size = Object.keys(payload.inspeccion).length;
        if (size > 0) {
            state.sitio_peritaje = payload.inspeccion.sitio_peritaje;
            state.encargado = payload.inspeccion.encargado;
            state.fecha = payload.inspeccion.fecha;
            state.hora = payload.inspeccion.hora;
        }
    }
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
